__turbopack_context__.v({
  "checkIcon": "WalletCollectionRow-module__rg41pq__checkIcon",
  "header": "WalletCollectionRow-module__rg41pq__header",
  "icon": "WalletCollectionRow-module__rg41pq__icon",
  "nameContainer": "WalletCollectionRow-module__rg41pq__nameContainer",
  "root": "WalletCollectionRow-module__rg41pq__root",
  "selectAll": "WalletCollectionRow-module__rg41pq__selectAll",
  "selectAllRow": "WalletCollectionRow-module__rg41pq__selectAllRow",
  "selectAllText": "WalletCollectionRow-module__rg41pq__selectAllText",
  "stat": "WalletCollectionRow-module__rg41pq__stat",
  "stats": "WalletCollectionRow-module__rg41pq__stats",
  "viewAll": "WalletCollectionRow-module__rg41pq__viewAll",
});
